<template>
  <div class="informasi_pendaftaran">
    <SOSlotBase
      :container-name="`informasi_pendaftaran_check`"
      :loading="isLoading"
    >
      <template v-slot:title-bar>
        <SOTitleBar
          :page-title="'Informasi Pendaftaran'"
          :type="'back'"
          @back="back"
        />
      </template>

      <template v-slot:loading-page>
        <SOLoadingPage />
      </template>
      <template v-slot:content>
        <div>
          <div class="d-flex-between-center container-cons">
            <div>
              <p class="m-d-0 f-c-midgrey f-12 f-regular">
                Setelah transaksi berhasil, quota Training akan bertambah dan
                dapat diakses di halaman Detail Training
              </p>
            </div>
          </div>
        </div>
        <div class="p-x-20 p-y-16 bg-white">
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey">Nama Program</div>
            <div class="f-regular f-16 f-c-black">Training Offline - Basic</div>
          </div>
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey">Nama Owner</div>
            <div class="f-regular f-16 f-c-black">Lilu Lalita</div>
          </div>
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey">No Telephone</div>
            <div class="f-regular f-16 f-c-black">+6282193749203</div>
          </div>
        </div>
        <div class="separator-line-dot p-d-8"></div>

        <h3 id="Detail">Jadwal Training</h3>
        <div class="p-x-20 p-y-16 bg-white">
          <label class="f-regular f-16 f-c-midgrey remove-margin require"
            >Pertemuan</label
          >
          <input
            type="text"
            class="form-control inputs"
            id="text_field"
            aria-describedby="emailHelp"
            value="4 Agustus 2023 11:00 - 13:00"
            readonly
            style="font-weight: bold; color: black; width: 100%"
          />
        </div>

        <div class="btn_bayar p-x-20">
          <button
            id="btn_bayar"
            type="button"
            class="btn btn-login btn-long remove-margin"
            style="width: 100%"
            @click="routeBayar"
          >
            Bayar
          </button>
        </div>
        <div style="margin-top: 10px"></div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

export default {
  name: "infomasiPendaftaran_Bayar_TrainingOfflineBasic",
  components: {
    SOTitleBar: SOTitleBar,
    SOSlotBase: SOSlotBase,
    SOLoadingPage: SOLoadingPage,
  },

  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    routeBayar() {
      this.$router.push({ name: "pembayaranPilih" });
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.container-cons {
  padding: 12px 20px;
  background-color: #f2f5f7;
  justify-content: unset;
}

#Detail {
  font-family: Overpass;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
  margin-left: 20px;
  margin-top: 10px;
}

@media (min-width: 320px) and (max-width: 424px) {
  .btn_bayar {
    margin-top: 42%;
  }
}

@media (min-width: 425px) and (max-width: 767px) {
  .btn_bayar {
    margin-top: 36%;
  }
}

@media (min-width: 768px) {
  .btn_bayar {
    margin-top: 22%;
  }
}

@media (min-width: 1024px) {
  .btn_bayar {
    margin-top: 34%;
  }
}

@media (min-width: 1440px) {
  .btn_bayar {
    margin-top: 32%;
  }
}
</style>
